import { makeCommonAuthState } from "../commonAuthState.mjs";
export const useAuthState = () => makeCommonAuthState();
export default useAuthState;
